import { render, staticRenderFns } from "./productScrap.vue?vue&type=template&id=2cf5971e&scoped=true&"
import script from "./productScrap.vue?vue&type=script&lang=js&"
export * from "./productScrap.vue?vue&type=script&lang=js&"
import style0 from "./productScrap.vue?vue&type=style&index=0&id=2cf5971e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf5971e",
  null
  
)

export default component.exports